import type { PageId } from 'constants/pages'
import type { PaymentSystem } from 'constants/rootConstants'
import type { PaymentRequestPaymentMethodEvent } from '@stripe/stripe-js'
import type { IPlanRaw } from 'models/plan.model'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface IGlobalLocalStore {
  checkoutContext: 'main' | 'upsell'
  createPaymentResFromDigitalWallet: PaymentRequestPaymentMethodEvent | null
  customToken: string
  emailConsent: boolean | null
  frcSettledDate: string | null
  hasPurchaseSuccessfullyCompleted: boolean
  isStoppedPolling: boolean
  learnWorldsEmailInitLeadId: string
  paymentSystem: PaymentSystem | null
  previousCohort: string // used only for detecting cohort changing
  previousLeadId: string // used only for detecting lead id changing
  purchaseId: string
  purchasePageId: PageId | null // needed to redirect user to the correct page in case reload during the purchase polling
  selectedLeadPlan: IPlanRaw | null
  hasUserManuallySelectedLeadPlan: boolean
  timerValue: number // timer value in seconds
}

const INITIAL_STORE: IGlobalLocalStore = {
  checkoutContext: 'main',
  createPaymentResFromDigitalWallet: null,
  customToken: '',
  emailConsent: null,
  frcSettledDate: null,
  hasPurchaseSuccessfullyCompleted: false,
  isStoppedPolling: false,
  learnWorldsEmailInitLeadId: '',
  paymentSystem: null,
  previousCohort: '',
  previousLeadId: '',
  purchaseId: '',
  purchasePageId: null,
  selectedLeadPlan: null,
  hasUserManuallySelectedLeadPlan: false,
  timerValue: 0,
}

export const useZustandGlobalLocalStore = create<IGlobalLocalStore>()(
  persist(() => INITIAL_STORE, {
    name: 'data-storage', // name of the item in the storage (must be unique)
  }),
)
export const useZustandLocalStore = useZustandGlobalLocalStore
